<script setup lang="ts">
import { computed } from 'vue';
import { Button } from '@toruslabs/vue-components/Button';
import MocaIconError from '../../assets/claim/moca-icon-error.svg';
import { useClaimStore } from '../../store/claimStore';

const claimStore = useClaimStore();
const errorText = computed(() => claimStore.errorText);
</script>

<template>
    <div class="flex flex-col items-center justify-center gap-6 tab:min-h-[400px]">
        <p class="text-moca-error-red text-2xl font-bold">Something went wrong</p>
        <img :src="MocaIconError" class="w-16 h-16" />
        <p class="text-moca-white-80 text-base font-semibold text-center">
            {{ errorText }}
        </p>
        <Button
            class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !w-48 !rounded-full !px-6"
            @on-click="() => claimStore.resetErrorMessage()">
            Back
        </Button>
    </div>
</template>
